import { mapState, mapMutations } from "vuex";

import { extend } from "quasar";
import { uuid } from "short-uuid";
import Others from "./others";

export default {
    mixins: [Others],
    computed: {
        ...mapState("components", ["components", "properties", "fragments"])
    },
    methods: {
        ...mapMutations("components", ["setData", "addComponent", "addComponentsPropertiesCategories", "setCurrentAddedComponent"]),
        getComponentEvents(component, properties) {
            const events = {};
            const customEvents = {};
            const compEvents = properties.__events;
            const compCustomEvents = properties.__customEvents;

            if (component.hasOwnProperty("events") && component.events.length) {
                component.events.forEach(event => {
                    events[event] = compEvents && compEvents.hasOwnProperty(event) ? (compEvents[event] || null) : null;
                });
            }

            if (component.hasOwnProperty("customEvents") && component.customEvents.length) {
                component.customEvents.forEach(event => {
                    customEvents[event] = compCustomEvents && compCustomEvents.hasOwnProperty(event) ? (compCustomEvents[event] || null) : null;
                });
            }

            if (compEvents) {
                delete properties.__events;
            }

            if (compCustomEvents) {
                delete properties.__customEvents;
            }
            return {
                __events: events,
                __customEvents: customEvents
            };
        },
        getComponentValidations(properties) {
            const validations = {
                validationType: "text",
                spCharactersErrMsg: "Special characters are not allowed",
                numbersErrMsg: "Numbers are not allowed",
                excludeSpCharacters: false,
                excludeNumbers: false,
                lengthState: false,
                minLengthValue: undefined,
                maxLengthValue: undefined,
                lengthErrMsg: "",
                intOrDecimalVal: "integer",
                dataFormatErrMsg: "Only integers are allowed",
                nrDecimals: 2,
                errMsgDecimal: "Maximum 2 decimal(s) allowed",
                otherErrMsg: "Wrong format",
                otherType: "regex",
                regexExpression: "",
                changeOrDefocus: "ondefocus",
                currentErrorMsg: ""
            };
            const compValidations = properties.__validations;

            if (compValidations) {
                Object.keys(validations).forEach(key => {
                    validations[key] = compValidations[key] || validations[key];
                });
            }

            return { __validations: validations };
        },
        getComponentGenerics(component, guid, properties) {
            const btnComponents = ["ctrl-button", "ctrl-api-button", "ctrl-download", "ctrl-export-csv", "ctrl-templates",
                "ctrl-process", "blockchain-button", "ctrl-metamask"];
            const { componentName } = component;
            const paddingTop = componentName && btnComponents.includes(componentName) ? 20 : 0;
            const generics = {
                /* eslint-disable object-property-newline */
                code: guid, share: false, hAlign: null, vAlign: null, display: true, readOnly: false, mandatory: false,
                sizeDesktop: 0, sizeTablet: 0, sizePhone: 12, padding: [paddingTop, 0, 0, 0], margin: [0, 0, 0, 0],
                mapLink: true, idComp: uuid()
                /* eslint-enable object-property-newline */
            };
            const compGenerics = properties.__generics;

            if (component) {
                if (component.hasOwnProperty("noSharing") && component.noSharing) {
                    delete generics.share;
                }
            }

            if (compGenerics) {
                Object.keys(generics).forEach(genericKey => {
                    if (compGenerics.hasOwnProperty(genericKey)) {
                        if (genericKey === "display") {
                            generics[genericKey] = true;
                        } else {
                            generics[genericKey] = compGenerics[genericKey];
                        }
                    } else if (genericKey === "mapLink") {
                        generics[genericKey] = false;
                    }
                });

                delete properties.__generics;
            }

            return { __component: component.componentName, __generics: { ...generics } };
        },
        getComponentDefaults(component) {
            const attributes = {}; const
                defaults = component.defaults || {};

            if (component && component.get) { attributes.get = null; }
            if (component && component.set) { attributes.set = null; }
            if (component && component.values) { attributes.values = null; }

            if (component.attributes) {
                component.attributes.forEach(attribute => {
                    attributes[attribute] = null;
                });
            }

            Object.entries(defaults).forEach(([key, value]) => {
                if (value.constructor === Object || value.constructor === Array) {
                    const clone = extend(true, {}, { value });
                    attributes[key] = clone.value;
                } else {
                    attributes[key] = value;
                }
            });

            return { ...attributes };
        },
        __loadFragment(json, startParent) {
            if (json) {
                const { components, body: fragmentBody } = json;

                const loadBody = (bodyList, parent) => {
                    bodyList.forEach(bodyEntry => {
                        const { body = [], guid } = bodyEntry;
                        const properties = components[guid];
                        properties.__generics.idComp = uuid();

                        properties.__fragment = startParent;

                        this.addComponent({
                            element: { guid }, properties, to: parent, fragment: true
                        });
                        if (body.length) {
                            loadBody(body, guid);
                        }
                    });
                };

                loadBody(fragmentBody, startParent);
            }
        },
        __createComponent(payload, addData = true) {
            const {
                type, guid = this.$generateUID(), to = "body", near = false, properties = {}, id
            } = payload;
            const component = this.components[type]; let
                allGood = true;

            if (component) {
                const element = { guid }; let combinedProperties; let generics; let defaults; let
                    events; let validations;
                if (type === "ctrl-fragment") {
                    generics = this.getComponentGenerics(component, guid, properties);
                    defaults = this.getComponentDefaults(component);
                    events = this.getComponentEvents(component, properties);
                    combinedProperties = {
                        ...generics, ...events, ...defaults, ...properties
                    };
                    combinedProperties.fragment = id || properties.fragment;
                } else if (type === "ctrl-slot") {
                    const parentConfig = this.components[this.properties[to].__component];
                    generics = this.getComponentGenerics(component, guid, properties);

                    combinedProperties = { ...generics, ...parentConfig.slot.defaults, ...properties };
                } else if (type === "ctrl-textbox" || type === "ctrl-textarea") {
                    generics = this.getComponentGenerics(component, guid, properties);
                    defaults = this.getComponentDefaults(component);
                    events = this.getComponentEvents(component, properties);
                    validations = this.getComponentValidations(properties);
                    combinedProperties = {
                        ...generics, ...events, ...defaults, ...validations, ...properties
                    };
                } else {
                    generics = this.getComponentGenerics(component, guid, properties);
                    defaults = this.getComponentDefaults(component);
                    events = this.getComponentEvents(component, properties);
                    combinedProperties = {
                        ...generics, ...events, ...defaults, ...properties
                    };
                }
                this.setCurrentAddedComponent(guid);
                this.addComponent({
                    element, properties: combinedProperties, to, near
                });

                if (type === "ctrl-fragment") {
                    const { interfaceJson } = extend(true, {}, this.fragments[id || properties.fragment]);
                    this.__loadFragment(interfaceJson, guid);
                }

                if (addData) {
                    const data = this.__generateData();
                    this.setData(data);
                }
            } else {
                console.log("Unknown component.");
                allGood = false;
                this.setCurrentAddedComponent();
            }

            return allGood;
        },
        __parseComponentCategories() {
            const firstLetterUpper = text => text.charAt(0).toUpperCase() + text.slice(1);
            const searchKey = "-options-";
            const parsedComponentObject = {};
            const globalComponents = window.Vue.options.components;
            const globalComponentsList = Object.keys(globalComponents).filter(componentName => componentName.includes(searchKey));
            const componentsList = Object.values(this.components).map(({ componentName }) => componentName);

            globalComponentsList.forEach(componentName => {
                const [component, category] = componentName.split(searchKey);

                if (component && category && componentsList.includes(component)) {
                    const { cid } = globalComponents[componentName];

                    if (!parsedComponentObject.hasOwnProperty(component)) {
                        parsedComponentObject[component] = { list: [], category: {} };
                    }

                    parsedComponentObject[component].list.push(cid);
                    parsedComponentObject[component].category[cid] = { label: firstLetterUpper(category), name: componentName };
                }
            });

            Object.entries(parsedComponentObject).forEach(([key, value]) => {
                const list = [];
                value.list.sort((a, b) => a - b).forEach(item => {
                    list.push({ ...value.category[item] });
                });
                this.addComponentsPropertiesCategories({ name: key, list });
            });
        }
    }
};
